import { Scrollbar, Mobile, TRANSITION_END } from '../core'

/*
* MLMI Locator
*/

const MAP_SELECTOR = '.map-chrome__google-map'
const MAP_LIST_ITEM = '.map-location'

export const MAP_STYLE = [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#302d2b"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#dfe4e8"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"labels.text.fill","stylers":[{"color":"#302d2b"}]},{"featureType":"landscape","elementType":"labels.text.stroke","stylers":[{"weight":"0.01"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"visibility":"simplified"},{"color":"#302d2b"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45},{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#ebebeb"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#302d2b"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#dfe4e8"},{"saturation":"10"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#302d2b"}]}]

const MAP_OPTIONS = {
  basicOptions: {
    zoom: 12,
    lat: 46.0725926,
    lng: -75.6866377,
    mapStyle: MAP_STYLE,
    autoFitBounds: false,
    enableGeolocation: false,
    enablePositionMarker: false,
  },
  clusterOptions: {
    useClusters: false,
  },
  bubbleOptions: {
    useBubbles: false,
  },
  getMarkerIcon: function(location) {
    let markerIcon = { height: 10, width: 10, anchorX: 5, anchorY: 5 }
    if (location.filters.indexOf('camping-sur-les-iles') !== -1) {
      markerIcon.url = '/img/markers/PB_Map_Camping_Iles_2.svg'
    } else if (location.filters.indexOf('camping-au-pied-de-la-montagne') !== -1) {
      markerIcon.url = '/img/markers/PB_Map_Camping_Montagne_2.svg'
    } else if (location.filters.indexOf('haltes-sur-les-iles') !== -1) {
      markerIcon.url = '/img/markers/PB_Map_Haltes_2.svg'
    } else if (location.filters.indexOf('activites') !== -1) {
      markerIcon.url = '/img/markers/PB_Map_Activite.svg'
    } else if (location.filters.indexOf('accueil') !== -1) {
      markerIcon.url = '/img/markers/PB_Map_Accueil.svg'
      markerIcon.width = 33
      markerIcon.height = 30
      markerIcon.anchorX = 16
      markerIcon.anchorY = 24
    } else if (location.filters.indexOf('refuge') !== -1) {
      markerIcon.url = '/img/markers/PB_Map_Refuge.svg'
    }
    return markerIcon
  },
}

let self, currentLocation

export default {
  locator: undefined,
  locations: [],
  panelScrollbar: undefined,
  mobileChecker: new Mobile(),
  kmlLayer: undefined,

  displayLocation(location_data) {
    /* Bail if same location */
    if (location_data.id == currentLocation) {
      return false
    }

    const $body = $('body'), $panel = $('.location-panel')
    currentLocation = location_data.id

    /* Removing current panel */
    let panelDelay = $body.hasClass('map--panel-open') ? 500 : 0
    $body.removeClass('map--panel-open')

    /* Displaying panel */
    setTimeout(function() {
      /* Build panel */
      $panel.find('h2').text(location_data.display_name)
      $panel.find('span.coords').text(location_data.coordonnees)
      $panel.find('div.description').text(location_data.description)
      if (location_data.distance) {
        $panel.find('.col-distance').show()
        $panel.find('.cell-distance').text(location_data.distance)
      } else {
        $panel.find('.col-distance').hide()
        $panel.find('.cell-distance').text('')
      }
      if (location_data.temps) {
        $panel.find('.col-temps').show()
        $panel.find('.cell-temps').text(location_data.temps)
      } else {
        $panel.find('.col-temps').hide()
        $panel.find('.cell-temps').text('')
      }
      if (location_data.secteur) {
        $panel.find('.col-secteur').show()
        $panel.find('.cell-secteur').text(location_data.secteur)
      } else {
        $panel.find('.col-secteur').hide()
        $panel.find('.cell-secteur').text('')
      }
      if (location_data.berge && location_data.berge != '–') {
        $panel.find('.col-berge').show()
        $panel.find('.cell-berge').text(location_data.berge)
      } else {
        $panel.find('.col-berge').hide()
        $panel.find('.cell-berge').text('')
      }
      if (location_data.acces) {
        $panel.find('.col-acces').show()
        $panel.find('.cell-acces').text(location_data.acces)
      } else {
        $panel.find('.col-acces').hide()
        $panel.find('.cell-acces').text('')
      }
      if (location_data.categorie) {
        $panel.find('.col-categorie').show()
        $panel.find('.cell-categorie').text(location_data.categorie)
      } else {
        $panel.find('.col-categorie').hide()
        $panel.find('.cell-categorie').text('')
      }
      if (location_data.niveau) {
        $panel.find('.col-niveau').show()
        $panel.find('.cell-niveau').text(location_data.niveau)
      } else {
        $panel.find('.col-niveau').hide()
        $panel.find('.cell-niveau').text('')
      }
      if (location_data.longueur) {
        $panel.find('.col-longueur').show()
        $panel.find('.cell-longueur').text(location_data.longueur)
      } else {
        $panel.find('.col-longueur').hide()
        $panel.find('.cell-longueur').text('')
      }
      if (location_data.altitude) {
        $panel.find('.col-altitude').show()
        $panel.find('.cell-altitude').text(location_data.altitude)
      } else {
        $panel.find('.col-altitude').hide()
        $panel.find('.cell-altitude').text('')
      }
      if (location_data.type) {
        $panel.find('.col-type').show()
        $panel.find('.cell-type').text(location_data.type)
      } else {
        $panel.find('.col-type').hide()
        $panel.find('.cell-type').text('')
      }
      if (location_data.denivele) {
        $panel.find('.col-denivele').show()
        $panel.find('.cell-denivele').text(location_data.denivele)
      } else {
        $panel.find('.col-denivele').hide()
        $panel.find('.cell-denivele').text('')
      }
      if (location_data.image) {
        $panel.find('.location-panel__thumbnail').css('visibility', 'visible').attr('src', location_data.image)
        $panel.find('.location-panel__thumbnail').attr('srcset', location_data.image + ' 1x, ' + location_data.image_2x + ' 2x')
      } else {
        $panel.find('.location-panel__thumbnail').css('visibility', 'hidden')
      }
      if (location_data.numero) {
        $panel.find('.location-panel__number').css('visibility', 'visible').text(location_data.numero)
      } else {
        $panel.find('.location-panel__number').css('visibility', 'hidden').text('')
      }
      // if (location_data.reservotron) {
      //   $panel.find('a.location-panel__cta').css('visibility', 'visible').attr('href', location_data.reservotron)
      // } else {
      //   $panel.find('a.location-panel__cta').css('visibility', 'hidden').attr('href', '#')
      // }
      if (location_data.galerie.length > 0) {
        $panel.find('.location-panel__view-photos').show()
        $panel.find('.location-panel__thumbnail-link').attr('href', location_data.galerie[0])
        $panel.find('.location-panel__gallery').empty()
        for (var i = 1; i < location_data.galerie.length; i++) {
          let link = $('<a>').attr('href', location_data.galerie[i]).attr('data-fancybox', 'map')
          $panel.find('.location-panel__gallery').append(link)
        }

        /* Initialize fancybox */
        $('[data-fancybox="map"]').fancybox({
          hash: false,
          buttons: ['close'],
        })

        /* Button click too */
        $('.location-panel__view-photos').on('click', function() {
          $('.location-panel__thumbnail-link').click()
        })
      } else {
        $panel.find('.location-panel__view-photos').hide()
      }

      /* Scroller & scrollbar */
      $panel.find('.scroller').scrollTop(0)
      if (self.locationScrollbar != undefined) {
        self.locationScrollbar.update()
      }

      /* Display panel */
      setTimeout(function() {
        $body.addClass('map--panel-open')
      }, 60)
    }, panelDelay)
  },

  init() {
    self = this
    this.attachEvents()
    this.attachScrollbars()
  },

  attachScrollbars() {
    /* Map scrollbars */
    new Scrollbar('.map-chrome__side-bar', {
      direction: 'vertical',
      mobile: false,
    })
    new Scrollbar('.map-chrome__side-bar', {
      direction: 'horizontal',
      desktop: false,
    })
    new Scrollbar('.map-chrome__top-bar', {
      direction: 'horizontal',
    })
    new Scrollbar('.map-chrome__sub-bar', {
      direction: 'horizontal',
    })
    this.locationScrollbar = new Scrollbar('.location-panel')
  },

  attachEvents() {
    if ($(MAP_SELECTOR).length) {
      /* Initialize map when ready */
      if ($.fn.MLMI_Locator == undefined) {
        setTimeout(self.attachEvents, 50)
      } else {
        /* Initialize map */
        self.locator = $(MAP_SELECTOR).MLMI_Locator(MAP_OPTIONS)

        /* Get locations for filtering */
        if ("locations" in window) {
          self.locations = window.locations
        }

        /* Marker clicked */
        self.locator.on('marker_clicked', function(event, map, marker) {
          let location_data = marker.location
          self.displayLocation(location_data)
        })

        /* KML Layer */
        self.kmlLayer = new google.maps.KmlLayer('https://poissonblanc.ca/img/markers/SentiersPB.kml?v=21', {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: self.locator.map,
        })

        /* KML Layer clicked */
        google.maps.event.addListener(self.kmlLayer, 'click', function(kmlEvent) {
          let location_id = parseInt(kmlEvent.featureData.id, 10)
          let location = self.locator.getMarker(location_id)
          if (location) {
            self.displayLocation(location.location)
          }
        })

        /* List item clicked */
        $(MAP_LIST_ITEM).each(function() {
          $(this).on('click', function() {
            let location_data = self.locator.getMarker($(this).data('id')).location
            self.displayLocation(location_data)

            /* Auto scroll on mobile */
            if (self.mobileChecker.isMobile) {
              let target = $('.map-chrome__map').offset().top,
              distance = Math.abs(target - $(document).scrollTop())
              $('html, body').animate({'scrollTop' : target}, 450 + distance / 5, 'swing')
            }
          })
        })

        /* Map clicked */
        self.locator.on('map_clicked', function(/*event, map*/) {
          $('body').removeClass('map--panel-open')
        })

        /* Filter clicked */
        $('.map-filters select').on('change', function() {
          let filters = []

          /* Display or hide filters level 2 */
          if ($(this).attr('name') == 'site_type') {
            $('.map-chrome__sub-bar').removeClass('visible')
            if ($('.map-chrome__sub-bar[data-parent="' + $(this).val() + '"]').length > 0) {
              $('.map-chrome__sub-bar[data-parent="' + $(this).val() + '"]').addClass('visible')
            }
          }

          /* Filters select */
          let filter1_value = $('select[name=site_type]').val()
          if (filter1_value != 'all') {
            filters.push(filter1_value)
            if (filter1_value == 'camping-sur-les-iles') {
              let filter2_value = $('select[name=site_category_iles]').val()
              if (filter2_value != 'all') {
                filters.push(filter2_value)
              }
            } else if (filter1_value == 'activites') {
              let filter2_value = $('select[name=site_category_activites]').val()
              if (filter2_value != 'all') {
                filters.push(filter2_value)
              }
            }
          }

          /* Filter */
          self.filter(filters)
        })
      }

      /* Close info panel */
      $('.location-panel__close').on('click', function() {
        currentLocation = undefined
        $('body').removeClass('map--panel-open')

        /* Auto scroll on mobile */
        if (self.mobileChecker.isMobile) {
          let target = $('.map-chrome').offset().top,
          distance = Math.abs(target - $(document).scrollTop())
          $('html, body').animate({'scrollTop' : target}, 450 + distance / 5, 'swing')
        }
      })
    }
  },

  filter(filters) {
    let oneTransitionEnd = true

    /* Fadeout all sidebar items */
    $('.map-locations').addClass('map-locations--hidden').on(TRANSITION_END, function() {
      if (oneTransitionEnd) {
        oneTransitionEnd = false

        /* All markers */
        self.locator.markers.forEach(function(marker) {
          let displayMarker = true, displayItem = true
          filters.forEach(function(filter) {
            if (marker.location.filters.indexOf("accueil") !== -1) {
              // always show maker
              displayItem = false
            } else if (marker.location.filters.indexOf(filter) === -1) {
              displayMarker = false
              displayItem = false
            }
          })
          if (displayMarker) {
            marker.setMap(self.locator.map)
          } else {
            marker.setMap(null)
          }
          if (displayItem) {
            $('.map-locations__item[data-id="' + marker.location.id + '"]').show()
          } else {
            $('.map-locations__item[data-id="' + marker.location.id + '"]').hide()
          }
        })

        /* Triangle patch Layer */
        const triangle = new google.maps.Polygon({
          paths: [
            { lat: 46.024047, lng: -75.698408 },
            { lat: 46.022701, lng: -75.698212 },
            { lat: 46.022713, lng: -75.698648 },
            { lat: 46.023228, lng: -75.698766 },
            { lat: 46.023108, lng: -75.699077 },
            { lat: 46.022594, lng: -75.699270 },
            { lat: 46.022353, lng: -75.699772 },
            { lat: 46.023982, lng: -75.700195 }
          ],
          strokeWeight: 0,
          fillColor: '#FFFFFF',
          fillOpacity: 1,
          clickable: false,
          draggable: false,
          editable: false,
        });
        triangle.setMap(self.locator.map);

        /* KML Layer */
        let displayKmlLayer = false
        if (!filters.length) {
          displayKmlLayer = true
        } else if (filters.length == 1 && filters[0] == 'activites') {
          displayKmlLayer = true
        } else {
          filters.forEach(function(filter) {
            if (filter == 'randonnees') {
              displayKmlLayer = true
            }
          })
        }
        if (displayKmlLayer) {
          self.kmlLayer.setMap(self.locator.map)
        } else {
          self.kmlLayer.setMap(null)
        }

        setTimeout(function() {
          $('.map-chrome__side-bar .scroller--horizontal').scrollLeft(0)
          $('.map-chrome__side-bar .scroller--vertical').scrollTop(0)
          $('.map-locations').removeClass('map-locations--hidden')
        }, 50)
      }
    })
  },
}
